import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'message-status',
    templateUrl: './message-status.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageStatusComponent {
    public readonly isMessagePending = input<boolean>(false);
}
